"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9522],{

/***/ 30866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PromoToasts; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./components/Alert.js + 10 modules
var Alert = __webpack_require__(16479);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./lib/clientStore.js
var clientStore = __webpack_require__(66208);
;// CONCATENATED MODULE: ./components/PromoToasts/useToasts.js





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var LOCAL_EXPIRATION_DURATION = 86400000;
// generate localstorage key
var getLocalStoreKey = function(toastId) {
    return "promo-toast-".concat(toastId);
};
var useToasts = function(param) {
    var type = param.type, params = param.params, userInitial = param.userInitial, setPromoToastVisible = param.setPromoToastVisible;
    var ref1 = (0,react.useState)(null), toast = ref1[0], setToast = ref1[1];
    (0,react.useEffect)(function() {
        var initialize = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, res, serverToast, localStoreKey, isLocalDismissed;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return (0,helpers/* makeApiCall */.Vo)({
                                apiArgs: [
                                    _objectSpread({}, params, {
                                        type: type
                                    })
                                ],
                                apiCall: api/* getPromoNotificationsApi */.H6W,
                                returnResponse: true
                            });
                        case 3:
                            res = _ctx.sent;
                            if ((res === null || res === void 0 ? void 0 : res.ok) && (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref[0])) {
                                serverToast = res.data[0];
                                localStoreKey = getLocalStoreKey(serverToast.id);
                                isLocalDismissed = clientStore/* localClientStore.get */.C.get(localStoreKey);
                                if (!isLocalDismissed) {
                                    setToast(serverToast);
                                }
                            }
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function initialize() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!userInitial && (type === "homepage" || type === "category" && (params === null || params === void 0 ? void 0 : params.categoryId) || type === "product" && (params === null || params === void 0 ? void 0 : params.sku))) {
            initialize();
        }
    }, [
        type,
        params,
        userInitial
    ]);
    (0,react.useEffect)(function() {
        if (toast) {
            setPromoToastVisible(true);
        } else {
            setPromoToastVisible(false);
        }
        return function() {
            return setPromoToastVisible(false);
        };
    }, [
        toast,
        setPromoToastVisible
    ]);
    var setToastRead = function(id) {
        // localstorage key for current toast
        var localStoreKey = getLocalStoreKey(id);
        var expiration = new Date().getTime() + LOCAL_EXPIRATION_DURATION;
        // set the new dismissed toast in localstorage
        clientStore/* localClientStore.set */.C.set(localStoreKey, "dismissed", expiration);
        setToast(null);
    };
    return {
        toast: toast,
        setToastRead: setToastRead
    };
};
/* harmony default export */ var PromoToasts_useToasts = (useToasts);

// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
;// CONCATENATED MODULE: ./components/PromoToasts/index.js








var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var PromoToasts = function(param) {
    var type = param.type, params = param.params, user = param.user, setPromoToastVisible1 = param.setPromoToastVisible, userDismissedNewsletter = param.userDismissedNewsletter;
    var ref1 = PromoToasts_useToasts({
        type: type,
        params: params,
        userInitial: user.isInitial,
        setPromoToastVisible: setPromoToastVisible1
    }), toast = ref1.toast, setToastRead = ref1.setToastRead;
    if (!toast) {
        return null;
    }
    // TODO add a way to update redux state for the user to dismiss the newsletter popup
    var isCookieConsentPopupVisible = Boolean(!clientStore/* cookieClientStore.get */.u.get("CookieConsent"));
    var isNewsletterPopupVisible = !userDismissedNewsletter;
    var positionClasses = classnames_default()("fixed z-10 right-0 sm:right-[15px] max-w-[420px] min-w-[320px] space-y-2", {
        // all are visible
        "bottom-0 sm:bottom-[100px] xl:bottom-[290px]": isNewsletterPopupVisible && isCookieConsentPopupVisible,
        // only cookies are visible
        "bottom-2 xl:bottom-[200px]": !isNewsletterPopupVisible && isCookieConsentPopupVisible,
        // only newsletter is visible
        "bottom-0 sm:bottom-[100px] xl:bottom-[100px]": isNewsletterPopupVisible && !isCookieConsentPopupVisible,
        // none are visible
        "bottom-0 sm:bottom-[8px]": !isNewsletterPopupVisible && !isCookieConsentPopupVisible
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: positionClasses,
        children: toast && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
            type: "blank",
            hasShadow: true,
            onClose: function() {
                return setToastRead(toast.id);
            },
            showIcon: !!(toast === null || toast === void 0 ? void 0 : toast.image),
            image: {
                src: "".concat(settings.cdn, "/media/label/image").concat(toast === null || toast === void 0 ? void 0 : toast.image),
                alt: toast.title
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-sm mr-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-red-brand font-medium",
                        children: toast.title
                    }),
                    (toast === null || toast === void 0 ? void 0 : toast.coupon_code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Cod:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                className: "font-medium",
                                children: toast.coupon_code
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: toast.description
                    }),
                    (toast === null || toast === void 0 ? void 0 : toast.url_link) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-[#0F62FE] underline",
                            href: toast.url_link,
                            children: toast.url_text || "Detalii"
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var components_PromoToasts = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user,
        userDismissedNewsletter: state.app.userDismissedNewsletter
    };
}, {
    setPromoToastVisible: actions/* setPromoToastVisible */.CA
})(PromoToasts));


/***/ }),

/***/ 46333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ResealedList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./components/ContentEditorView/index.js + 24 modules
var ContentEditorView = __webpack_require__(51961);
// EXTERNAL MODULE: ./components/ProductList/ProductListResealedItem.js
var ProductListResealedItem = __webpack_require__(11427);
;// CONCATENATED MODULE: ./components/ProductList/ProductListResealed.js



var getProductsPerRow = function(param) {
    var _listType = param.listType, listType = _listType === void 0 ? "default" : _listType, width = param.width;
    if (width < 640) return 2;
    if (listType === "wishlist") {
        return 3;
    }
    if (width < 1021) return 3;
    return 4;
};
var getProductsInCurrentRow = function(param) {
    var products = param.products, index = param.index, productsPerRow = param.productsPerRow;
    var currentRowStartIndex = Math.floor(index / productsPerRow) * productsPerRow;
    var currentRowEndIndex = currentRowStartIndex + productsPerRow - 1;
    return products.slice(currentRowStartIndex, currentRowEndIndex + 1);
};
var ProductListResealed = function(param) {
    var products = param.products, onProductClick = param.onProductClick;
    var observerRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(), width = ref1[0], setWidth = ref1[1];
    (0,react.useEffect)(function() {
        observerRef.current = new ResizeObserver(function(entries) {
            setWidth(entries[0].contentRect.width);
        });
        observerRef.current.observe(document.querySelector("body"));
        return function() {
            observerRef.current.disconnect();
        };
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "Products flex flex-wrap relative -mx-1 sm:-mx-2",
        children: products.map(function(product, i) {
            var productsPerRow = getProductsPerRow({
                width: width
            });
            var productsInCurrentRow = getProductsInCurrentRow({
                products: products,
                index: i,
                productsPerRow: productsPerRow
            });
            var hasColorVariationsInCurrentRow = productsInCurrentRow.some(function(p) {
                var ref;
                return ((ref = p.configurable_options) === null || ref === void 0 ? void 0 : ref.length) && p.configurable_options.find(function(option) {
                    return option.attribute_code === "culoare_global";
                });
            });
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListResealedItem/* default */.Z, {
                product: product,
                onProductClick: onProductClick,
                hasColorVariationsInCurrentRow: hasColorVariationsInCurrentRow
            }, product.id + "-" + i));
        })
    }));
};
/* harmony default export */ var ProductList_ProductListResealed = (ProductListResealed);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./lib/filterUtil.js
var filterUtil = __webpack_require__(82594);
// EXTERNAL MODULE: ./components/Modal.js
var Modal = __webpack_require__(12280);
// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./components/Filters/ActiveFilters.js + 1 modules
var ActiveFilters = __webpack_require__(86517);
// EXTERNAL MODULE: ./components/Filters/FilterGroup.js + 2 modules
var FilterGroup = __webpack_require__(68533);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./components/Filters/ResealedNav.js






function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
var ResealedNav = function(param1) {
    var categories = param1.categories, removeModal1 = param1.removeModal;
    var handleClick = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return removeModal1();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "divide-y-[1px] md:border-y-[1px] md:border-gray-400 divide-gray-400 text-[16px] leading-[20px] font-medium",
        children: categories.map(function(param) {
            var name = param.name, url_key = param.url_key, isActive = param.isActive;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                className: "py-[8px] ".concat(isActive ? "text-[#ADADAD]" : ""),
                children: isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: isBricoStore ? "bd-claim inline-block" : "",
                    children: name
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/resigilate/".concat(url_key, "/cpl"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: _asyncToGenerator(runtime_default().mark(function _callee() {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        return _ctx.abrupt("return", handleClick());
                                    case 1:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: isBricoStore ? "bd-claim inline-block" : "",
                            children: name
                        })
                    })
                })
            }, url_key);
        })
    }));
};
/* harmony default export */ var Filters_ResealedNav = ((0,es/* connect */.$j)(null, {
    removeModal: actions/* removeModal */.a_
})(ResealedNav));

// EXTERNAL MODULE: ./lib/GTMHelper.js
var GTMHelper = __webpack_require__(17242);
;// CONCATENATED MODULE: ./components/Filters/ResealedFilters.js












function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ResealedFilters = function(param) {
    var name = param.name, activeFilters = param.activeFilters, filters = param.filters, query = param.query, totalProducts = param.totalProducts, extractedFiltersParams = param.extractedFiltersParams, removeModal1 = param.removeModal, navigationCategories = param.navigationCategories;
    var hasActiveFilters = Boolean(activeFilters.length);
    var handleFilterMobileApply = function(parentSlug, filter1, generalSlugs) {
        var filQuery = _objectSpread({}, extractedFiltersParams.filters);
        // we remove existing values for this filter group as we always send all active values in the callback
        parentSlug ? delete filQuery[parentSlug] : generalSlugs.forEach(function(slug) {
            return delete filQuery[slug];
        });
        var url = (0,filterUtil/* addRemoveUrlResealed */.tq)("add", filter1.filters.map(function(filterOption) {
            return {
                filter: filterOption.attributeSlug || parentSlug,
                filterValue: filterOption.slug,
                replaceValue: false
            };
        }), filQuery, "list", query || {});
        //GTM tracking start
        var operation = filter1.filters.length === 0 || filter1.filters.every(function(filter) {
            return filter.isActive;
        }) ? "remove" : "add";
        if (operation === "add") {
            (0,GTMHelper/* setGTMProductsFilterApply */.xr)({
                addedFilters: filter1,
                activeFilters: activeFilters
            });
        } else {
            (0,GTMHelper/* setGTMProductsFilterRemove */.bO)({
                removedFilters: filter1,
                activeFilters: activeFilters
            });
        }
        // GTM tracking end
        removeModal1();
        router["default"].push(url);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden lg:block lg:w-1/5 lg:mt-3 sm:pr-6",
                children: [
                    navigationCategories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-[60px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_ResealedNav, {
                            categories: navigationCategories
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "Filters",
                        id: "catalog-filters-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: filters.map(function(filter, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(FilterGroup/* default */.Z, {
                                    filter: filter,
                                    isModal: false,
                                    isLast: index == filters.length - 1,
                                    onFilterMobileApply: handleFilterMobileApply,
                                    activeFilters: activeFilters
                                }, index);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                id: "resealed",
                header: name,
                hasStickyHeader: true,
                hasStickyFooter: true,
                hasRadius: false,
                children: navigationCategories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-[60px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_ResealedNav, {
                        categories: navigationCategories
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal["default"], {
                id: "filters",
                header: "Filtreaza",
                hasStickyHeader: true,
                hasStickyFooter: true,
                hasRadius: false,
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex space-x-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "py-2 px-5 text-14px border-2 border-transparent bg-filterYellow w-full rounded-bl-lg rounded-tr-lg",
                                onClick: function() {
                                    return removeModal1();
                                },
                                children: [
                                    "Vezi ",
                                    totalProducts,
                                    " ",
                                    totalProducts !== 1 ? "produse" : "produs"
                                ]
                            }),
                            hasActiveFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: activeFilters.find(function(el) {
                                    return el.removeAll;
                                }).removeUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "py-2 px-5 text-center text-14px border-2 border-filterYellow w-full rounded-bl-lg rounded-tr-lg",
                                    onClick: function() {
                                        return removeModal1();
                                    },
                                    children: "Sterge tot"
                                })
                            })
                        ]
                    })
                }),
                children: [
                    hasActiveFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "Filters-group Filters-group--remove js-active-filters mb-4 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveFilters/* default */.Z, {
                            activeFilters: activeFilters
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:mt-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "Filters",
                            id: "catalog-filters-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: filters.map(function(filter, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(FilterGroup/* default */.Z, {
                                        filter: filter,
                                        isModal: true,
                                        onFilterMobileApply: handleFilterMobileApply,
                                        isLast: index == filters.length - 1,
                                        activeFilters: activeFilters
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
ResealedFilters.propTypes = {
    filters: (prop_types_default()).array.isRequired,
    extractedFiltersParams: (prop_types_default()).object.isRequired
};
/* harmony default export */ var Filters_ResealedFilters = ((0,es/* connect */.$j)(null, {
    removeModal: actions/* removeModal */.a_
})(ResealedFilters));

// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
;// CONCATENATED MODULE: ./components/ResealedSort.js









function ResealedSort_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ResealedSort_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ResealedSort_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ResealedSort_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ResealedSort = function(param1) {
    var toolbar = param1.toolbar, navigationCategories = param1.navigationCategories, isModal = param1.isModal, addModal1 = param1.addModal, removeModal1 = param1.removeModal;
    var ref3 = (0,react.useState)(toolbar), toolbarState = ref3[0], setToolbarState = ref3[1];
    var ref1 = (0,react.useState)(null), selectedSort = ref1[0], setSelectedSort = ref1[1];
    var push = (0,router.useRouter)().push;
    var getSelected = function(sort) {
        var ref, ref2;
        var activeUrl = (ref = sort.find(function(option) {
            return option.active;
        })) === null || ref === void 0 ? void 0 : ref.url;
        if (activeUrl) {
            return activeUrl;
        }
        var defaultUrl = (ref2 = sort.find(function(option) {
            return option.default;
        })) === null || ref2 === void 0 ? void 0 : ref2.url;
        if (defaultUrl) {
            return defaultUrl;
        }
    };
    var trackSortChange = function(url) {
        var newSortOption = toolbar.sort.find(function(x) {
            return x.url === url;
        });
        (0,GTMHelper/* setGTMProductsSortOptions */.pN)(newSortOption.name);
    };
    if (isModal) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
            id: "toolbar",
            onRemoveModal: function() {
                return setToolbarState(toolbar);
            },
            header: "Sorteaza",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "Toolbar flow-root Toolbar--modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "Form-select",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            className: "!max-w-lg mx-auto block",
                            defaultValue: getSelected(toolbar.sort),
                            onChange: function(event) {
                                return setSelectedSort(event.target.value);
                            },
                            children: toolbarState.sort.map(function(param) {
                                var url = param.url, name = param.name;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                    value: url,
                                    children: name
                                }, url);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 max-w-lg mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: ResealedSort_asyncToGenerator(runtime_default().mark(function _callee() {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return removeModal1();
                                        case 2:
                                            if (selectedSort) {
                                                trackSortChange(selectedSort);
                                                push(selectedSort);
                                            }
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })),
                            variant: "primary",
                            title: "Aplica",
                            display: "block"
                        })
                    })
                ]
            })
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "Toolbar pb-4 mt-15px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-flow-row grid-cols-2 grid-rows-2 gap-4 justify-between lg:hidden",
                children: [
                    navigationCategories && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "flex col-span-2 justify-center items-center py-2 px-5 border rounded-bl-lg rounded-tr-lg border-primary text-black",
                        onClick: function() {
                            return addModal1("resealed");
                        },
                        children: "Categorii produse resigilate"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "flex justify-center items-center py-2 px-5 border rounded-bl-lg rounded-tr-lg border-primary text-black",
                        onClick: function() {
                            return addModal1("filters");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "pr-2 flex-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "19",
                                    height: "17",
                                    viewBox: "0 0 19 17",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M18 1H0L7.2 9.40889V15.2222L10.8 17V9.40889L18 1V1Z",
                                        stroke: "black",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            }),
                            "Filtreaza"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "flex justify-center items-center py-2 px-5 border rounded-bl-lg rounded-tr-lg border-primary text-black",
                        onClick: function() {
                            return addModal1("toolbar");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "pr-2 flex-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    width: "21",
                                    height: "17",
                                    viewBox: "0 0 21 17",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                            id: "path-1-inside-1",
                                            fill: "white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                width: "21",
                                                height: "5",
                                                rx: "1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            width: "21",
                                            height: "5",
                                            rx: "1",
                                            stroke: "black",
                                            strokeWidth: "4",
                                            mask: "url(#path-1-inside-1)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                            id: "path-2-inside-2",
                                            fill: "white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                y: "6",
                                                width: "17",
                                                height: "5",
                                                rx: "1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            y: "6",
                                            width: "17",
                                            height: "5",
                                            rx: "1",
                                            stroke: "black",
                                            strokeWidth: "4",
                                            mask: "url(#path-2-inside-2)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                            id: "path-3-inside-3",
                                            fill: "white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                y: "12",
                                                width: "13",
                                                height: "5",
                                                rx: "1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            y: "12",
                                            width: "13",
                                            height: "5",
                                            rx: "1",
                                            stroke: "black",
                                            strokeWidth: "4",
                                            mask: "url(#path-3-inside-3)"
                                        })
                                    ]
                                })
                            }),
                            "Sorteaza"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden lg:inline-flex items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "Form-select w-[220px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                        className: "!max-w-lg mx-auto block",
                        value: getSelected(toolbar.sort),
                        onChange: function() {
                            var _ref = ResealedSort_asyncToGenerator(runtime_default().mark(function _callee(e) {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            trackSortChange(e.target.value);
                                            push(e.target.value);
                                            window.scrollTo(0, 0);
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(e) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        children: toolbar.sort.map(function(option) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                value: "".concat(option.url),
                                children: option.name
                            }, option.url);
                        })
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var components_ResealedSort = ((0,es/* connect */.$j)(null, {
    addModal: actions/* addModal */.Y_,
    removeModal: actions/* removeModal */.a_
})(ResealedSort));

// EXTERNAL MODULE: ./store/tracker/actions.js + 1 modules
var tracker_actions = __webpack_require__(48712);
// EXTERNAL MODULE: ./containers/Catalog/CompareWidget.js + 1 modules
var CompareWidget = __webpack_require__(1144);
// EXTERNAL MODULE: ./components/Banners.js
var Banners = __webpack_require__(225);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./components/PaginationWithLinks/index.js + 2 modules
var PaginationWithLinks = __webpack_require__(78880);
// EXTERNAL MODULE: ./store/resealed/actions.js
var resealed_actions = __webpack_require__(74577);
;// CONCATENATED MODULE: ./containers/Catalog/ResealedList.js




















function ResealedList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ResealedList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ResealedList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ResealedList_ref = (0,config["default"])(), ResealedList_publicRuntimeConfig = ResealedList_ref.publicRuntimeConfig, _settings = ResealedList_publicRuntimeConfig.settings, websiteStatics = _settings.websiteStatics, baseUrl = _settings.baseUrl, ResealedList_websiteName = _settings.websiteName;
var ResealedList_isBricoStore = ResealedList_websiteName === "bricostore";
var findParentCategoryById = function(categoryId, categories) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = categories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            var ref1;
            if (category.id === categoryId) {
                return category;
            }
            if (((ref1 = category.subcategories) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                var result = findParentCategoryById(categoryId, category.subcategories);
                if (result) {
                    return result;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
var getParentCategorySubcategories = function(categories) {
    var subcategories = categories// TODO: This is an API problem
    // Category tree returns categories without products
    // Worst case scenario, this should be moved to the API transformer
    // TODO: Verify if backend returns categories with resealed_count 0
    // and remove code if it's fixed
    .filter(function(category) {
        return category.resealed_count;
    }).sort(function(a, b) {
        return a.id - b.id;
    });
    return subcategories.length ? subcategories : null;
};
var CatalogResealedList = function(param) {
    var query = param.query, currentCategory = param.currentCategory, trackProductClick1 = param.trackProductClick, extractedFiltersParams = param.extractedFiltersParams, resealedTree = param.resealedTree;
    var ref2;
    var asPath = (0,router.useRouter)().asPath;
    var _breadcrumbs = currentCategory.breadcrumbs, breadcrumbs = _breadcrumbs === void 0 ? [] : _breadcrumbs, products = currentCategory.products, filters = currentCategory.filters, activeFilters = currentCategory.activeFilters, meta = currentCategory.meta, toolbar = currentCategory.toolbar;
    var _category = currentCategory.category, _meta_title = _category.meta_title, meta_title = _meta_title === void 0 ? "" : _meta_title, _meta_description = _category.meta_description, meta_description = _meta_description === void 0 ? "" : _meta_description, _meta_keywords = _category.meta_keywords, meta_keywords = _meta_keywords === void 0 ? "" : _meta_keywords, meta_robots = _category.meta_robots, seo_canonical = _category.seo_canonical, _seo_alternate_canonical = _category.seo_alternate_canonical, seo_alternate_canonical = _seo_alternate_canonical === void 0 ? "" : _seo_alternate_canonical, seo_title = _category.seo_title, name = _category.name, _description = _category.description, description = _description === void 0 ? null : _description, _description_editor_object = _category.description_editor_object, description_editor_object = _description_editor_object === void 0 ? null : _description_editor_object, landing_page = _category.landing_page, banners = _category.banners, url_key = _category.url_key, subcategories = _category.subcategories, parent_id = _category.parent_id, thumbnail = _category.thumbnail;
    var hasSubcategories = Boolean(subcategories === null || subcategories === void 0 ? void 0 : subcategories.length);
    var parentCategory = typeof parent_id === "number" && findParentCategoryById(parent_id, resealedTree);
    var parentSubcategories = Boolean(parentCategory === null || parentCategory === void 0 ? void 0 : (ref2 = parentCategory.subcategories) === null || ref2 === void 0 ? void 0 : ref2.length) && getParentCategorySubcategories(parentCategory.subcategories);
    var hasParentSubcategories = Boolean(parentSubcategories === null || parentSubcategories === void 0 ? void 0 : parentSubcategories.length);
    var navigationCategories = hasSubcategories ? // Remove when backend does that
    subcategories.sort(function(a, b) {
        return a.id - b.id;
    }) : hasParentSubcategories && parentSubcategories;
    var navigationCategoriesWithActiveState = navigationCategories && (navigationCategories === null || navigationCategories === void 0 ? void 0 : navigationCategories.map(function(category) {
        return ResealedList_objectSpread({}, category, {
            isActive: category.url_key === url_key
        });
    }));
    var totalProducts = (meta === null || meta === void 0 ? void 0 : meta.items) || 0;
    var parsedDescriptionObject;
    if (description_editor_object) {
        try {
            parsedDescriptionObject = JSON.parse(description_editor_object);
        } catch (error) {
            parsedDescriptionObject = false;
        }
    }
    (0,react.useEffect)(function() {
        if ((products === null || products === void 0 ? void 0 : products.length) > 0) {
            (0,GTMHelper/* setGTMProductsImpressions */.SS)(products.map(function(product, index) {
                return ResealedList_objectSpread({}, product, {
                    index: index + 1,
                    categoryPath: breadcrumbs,
                    item_list_name: "Produse resigilate"
                });
            }));
        }
    }, [
        products,
        breadcrumbs
    ]);
    var Meta = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(head["default"], {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: meta_title || name
                }),
                meta_description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: meta_description
                }),
                meta_keywords.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "keywords",
                    content: meta_keywords
                }),
                thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:image",
                    content: (0,helpers/* resizeImage */.tg)(thumbnail, "600x600")
                }),
                (meta_robots === null || meta_robots === void 0 ? void 0 : meta_robots.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "robots",
                    content: meta_robots
                }),
                seo_canonical && !(seo_alternate_canonical === null || seo_alternate_canonical === void 0 ? void 0 : seo_alternate_canonical.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "canonical",
                    href: "".concat(baseUrl).concat(asPath)
                }),
                seo_canonical && (seo_alternate_canonical === null || seo_alternate_canonical === void 0 ? void 0 : seo_alternate_canonical.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "alternate",
                    href: seo_alternate_canonical
                })
            ]
        });
    };
    var ListLayout = function() {
        var ref9, ref3, ref4, ref5, ref6, ref7, ref8;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_ResealedFilters, {
                        activeFilters: activeFilters,
                        filters: filters,
                        extractedFiltersParams: extractedFiltersParams,
                        query: query,
                        totalProducts: totalProducts,
                        navigationCategories: navigationCategoriesWithActiveState,
                        name: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(products.length > 0 ? "lg:w-4/5" : "lg:mt-8", " "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "block md:flex md:items-baseline",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                        as: "h1",
                                        title: seo_title || name,
                                        display: "h1",
                                        sameSizeOnMobile: true
                                    }),
                                    totalProducts > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "md:ml-2 font-normal text-22px leading-7 ".concat(ResealedList_isBricoStore ? "text-[#9F9FA9]" : "text-gray-light"),
                                        children: [
                                            "(",
                                            totalProducts,
                                            " ",
                                            totalProducts === 1 ? "produs" : "produse",
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            (banners === null || banners === void 0 ? void 0 : (ref9 = banners[0]) === null || ref9 === void 0 ? void 0 : (ref3 = ref9.images_mobile) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners/* default */.Z, {
                                    items: banners[0].images_mobile
                                })
                            }),
                            (banners === null || banners === void 0 ? void 0 : (ref4 = banners[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.images_tablet) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden sm:block lg:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners/* default */.Z, {
                                    items: banners[0].images_tablet
                                })
                            }),
                            (banners === null || banners === void 0 ? void 0 : (ref6 = banners[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.images) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden lg:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners/* default */.Z, {
                                    items: banners[0].images
                                })
                            }),
                            (landing_page === null || landing_page === void 0 ? void 0 : landing_page.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: landing_page.content
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveFilters/* default */.Z, {
                                        activeFilters: activeFilters
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResealedSort, {
                                        toolbar: toolbar,
                                        navigationCategories: navigationCategoriesWithActiveState
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList_ProductListResealed, {
                                        products: products.map(function(product, index) {
                                            return ResealedList_objectSpread({}, product, {
                                                index: index + 1,
                                                categoryPath: breadcrumbs,
                                                item_list_name: "Produse resigilate"
                                            });
                                        }),
                                        filter: extractedFiltersParams,
                                        onProductClick: trackProductClick1
                                    }),
                                    (toolbar === null || toolbar === void 0 ? void 0 : (ref8 = toolbar.paginationBottom) === null || ref8 === void 0 ? void 0 : ref8.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex justify-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationWithLinks/* default */.Z, {
                                                    pagination: toolbar.paginationBottom
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-center mt-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                    as: "h3",
                                                    display: "h6",
                                                    title: "".concat(meta.items, " ").concat(meta.items === 1 ? "produs" : "produse")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResealedSort, {
                                        toolbar: toolbar,
                                        navigationCategories: navigationCategoriesWithActiveState,
                                        isModal: true
                                    })
                                ]
                            }),
                            Object.keys(extractedFiltersParams.filters).length === 0 && Object.keys(extractedFiltersParams.otherParams).length === 0 && (parsedDescriptionObject ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView/* default */.Z, {
                                content: parsedDescriptionObject
                            }) : (description === null || description === void 0 ? void 0 : description.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "my-10",
                                children: description
                            }))
                        ]
                    })
                ]
            })
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                breadcrumbs: breadcrumbs
            }),
            (products === null || products === void 0 ? void 0 : products.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLayout, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col md:flex-row items-center justify-center md:justify-start gap-6 my-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "w-[158px]",
                        src: "".concat(websiteStatics, "/images/cart/empty-cart.svg"),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        title: seo_title || /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Nu au fost gasite produse conform criteriilor selectate."
                        }),
                        as: "h1",
                        display: "h6",
                        classesProp: "max-w-[639px]"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareWidget/* default */.Z, {})
        ]
    }));
};
/* harmony default export */ var ResealedList = ((0,es/* connect */.$j)(function(state) {
    return {
        currentCategory: state.resealed.currentCategory,
        extractedFiltersParams: state.resealed.extractedFiltersParams,
        resealedTree: state.resealed.tree
    };
}, {
    trackProductClick: tracker_actions/* trackProductClick */.Cg,
    getCategoryResealed: resealed_actions/* getCategoryResealed */.R
})(CatalogResealedList));


/***/ }),

/***/ 74577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getCategoryResealedTree; },
/* harmony export */   "R": function() { return /* binding */ getCategoryResealed; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _lib_filterUtil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82594);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15722);
/* harmony import */ var _store_resealed_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49674);
/* harmony import */ var _lib_api_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45963);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2642);






function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var getCategoryResealedTree = function() {
    return (function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState) {
            var date1, timestamp1, cacheTime, ref, ref1, tree, treeLastUpdatedAt;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        date1 = new Date();
                        timestamp1 = date1.getTime();
                        cacheTime = 5 * 60 * 1000; // minutes * seconds * milliseconds
                        if (!_lib_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isServer */ .sk) {
                            _ctx.next = 7;
                            break;
                        }
                        ;
                        if (!((__webpack_require__.g === null || __webpack_require__.g === void 0 ? void 0 : (ref = __webpack_require__.g.resealed) === null || ref === void 0 ? void 0 : ref.tree) && (__webpack_require__.g === null || __webpack_require__.g === void 0 ? void 0 : (ref1 = __webpack_require__.g.resealed) === null || ref1 === void 0 ? void 0 : ref1.treeLastUpdatedAt) && timestamp1 - __webpack_require__.g.resealed.treeLastUpdatedAt < cacheTime)) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", dispatch({
                            type: _store_resealed_constants__WEBPACK_IMPORTED_MODULE_5__/* .GET_CATEGORY_RESEALED_TREE_SUCCESS */ .kS,
                            payload: __webpack_require__.g.resealed.tree
                        }));
                    case 7:
                        if (_lib_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isServer */ .sk) {
                            _ctx.next = 12;
                            break;
                        }
                        tree = getState().resealed.tree;
                        treeLastUpdatedAt = getState().resealed.treeLastUpdatedAt;
                        if (!(tree && treeLastUpdatedAt && timestamp1 - treeLastUpdatedAt < cacheTime)) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return", dispatch({
                            type: _store_resealed_constants__WEBPACK_IMPORTED_MODULE_5__/* .GET_CATEGORY_RESEALED_TREE_CACHE_SUCCESS */ .H1
                        }));
                    case 12:
                        return _ctx.abrupt("return", (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_3__/* .makeApiCall */ .Vo)({
                            actions: {
                                action: _store_resealed_constants__WEBPACK_IMPORTED_MODULE_5__/* .GET_CATEGORY_RESEALED_TREE */ .DF,
                                success: _store_resealed_constants__WEBPACK_IMPORTED_MODULE_5__/* .GET_CATEGORY_RESEALED_TREE_SUCCESS */ .kS,
                                fail: _store_resealed_constants__WEBPACK_IMPORTED_MODULE_5__/* .GET_CATEGORY_RESEALED_TREE_FAILURE */ .xu
                            },
                            dispatch: dispatch,
                            getState: getState,
                            spinner: false,
                            alert: true,
                            alertMessage: "Get resealed category tree couldn't be completed...",
                            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_4__/* .getCategoryTreeResealedApi */ .BZr,
                            formatResponse: function(response) {
                                return response.data;
                            },
                            postSuccess: function(response) {
                                if (_lib_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isServer */ .sk && __webpack_require__.g) {
                                    var date = new Date();
                                    var timestamp = date.getTime();
                                    __webpack_require__.g.resealed = {
                                        tree: response.data,
                                        treeLastUpdatedAt: timestamp
                                    };
                                }
                            }
                        }));
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    })();
};
var getCategoryResealed = function(query, extractedFiltersParams) {
    return function(dispatch, getState) {
        var urlPath = query.urlKey;
        var apiArgs = [
            urlPath ? encodeURIComponent(urlPath) : "",
            extractedFiltersParams.apiQueryParams, 
        ];
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_3__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_resealed_constants__WEBPACK_IMPORTED_MODULE_5__/* .GET_CATEGORY_RESEALED */ .HK,
                success: _store_resealed_constants__WEBPACK_IMPORTED_MODULE_5__/* .GET_CATEGORY_RESEALED_SUCCESS */ .dE,
                fail: _store_resealed_constants__WEBPACK_IMPORTED_MODULE_5__/* .GET_CATEGORY_RESEALED_FAILURE */ .r7
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            alert: true,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_4__/* .getCategoryResealedApi */ .ZIS,
            apiArgs: apiArgs,
            returnResponse: true,
            formatResponse: function(response) {
                var ref;
                var data = response.data;
                if (((ref = data.layeredNavigation) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                    var priceIndex = data.layeredNavigation.findIndex(function(p) {
                        return p.attribute_code === "price";
                    });
                    data.layeredNavigation[priceIndex].filters.forEach(function(filter) {
                        filter.slug = filter.slug.replace("_", "-");
                    });
                }
                var res = {
                    data: data,
                    urlPath: urlPath
                };
                if (res.data.breadcrumbs) {
                    res.data.breadcrumbs.forEach(function(breadcrumb) {
                        if (breadcrumb.url_key) {
                            breadcrumb.url_key = "resigilate/".concat(breadcrumb.url_key);
                            breadcrumb.url_suffix = "/cpl/";
                        }
                    });
                    // Push at the beginning the default route in breadcrumbs
                    res.data.breadcrumbs.unshift({
                        name: "Produse resigilate",
                        url_key: "resigilate/",
                        id: 1,
                        level: res.data.breadcrumbs.length === 0 ? 99 : 1
                    });
                }
                var ref2 = (0,_lib_filterUtil__WEBPACK_IMPORTED_MODULE_1__/* .formatResealedFilters */ .lx)(data.layeredNavigation, extractedFiltersParams, "category", query), filters = ref2.filters, activeFilters = ref2.activeFilters;
                var toolbar = (0,_lib_filterUtil__WEBPACK_IMPORTED_MODULE_1__/* .makeResealedToolbar */ .G3)(data.meta, "category", extractedFiltersParams, query);
                res.data.filters = filters;
                res.data.activeFilters = activeFilters;
                res.data.toolbar = toolbar;
                res.extractedFiltersParams = extractedFiltersParams;
                return res;
            }
        });
    };
};


/***/ })

}]);